import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useWebsocketEventSubscription } from '@frontend/websocket';

export const useWebsocketAppointmentEventSubscription = () => {
  const { invalidateListCalendarEvents, invalidateListCalendarEventsByAttendee } =
    SchedulerV3.Helpers.useSchedulerV3InvalidateQueries();

  // Invalidate the list of calendar events for the date when an appointment is created, updated or deleted
  return useWebsocketEventSubscription(NotificationType.APPOINTMENT_CHANGED, (payload) => {
    invalidateListCalendarEvents({
      locationId: payload.params.locationId,
      startDateTime: payload.params.startDatetime,
      endDateTime: payload.params.endDatetime,
      oldStartDateTime: payload.params.priorData?.startDatetime,
      oldEndDateTime: payload.params.priorData?.endDatetime,
    });
    if (payload.params.locationId) {
      invalidateListCalendarEventsByAttendee(payload.params.locationId);
    }
  });
};
